import { Form, Formik } from 'formik';
import { Badge, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import InputFormGroup from '../util/InputFormGroup';
import useTheme from '../hooks/useTheme';
import { useCloudServiceEmailFormHandlers } from './useCloudServiceEmailFormHandlers';

function CloudServiceEmail({ onComplete, onCancel }) {
  const [theme] = useTheme();
  const { handleSubmit, handleCancel, errorMsg } =
    useCloudServiceEmailFormHandlers(onComplete, onCancel);

  return (
    <>
      <Badge variant="danger">{errorMsg}</Badge>
      <p>
        RealConnect Hybrid requires an active Poly Cloud Service account. This
        account facilitates a device&apos;s self-discovery upon service start.
      </p>
      <Formik
        initialValues={{
          cloudServiceEmail: '',
        }}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, values }) => (
          <Form>
            <br />
            <InputFormGroup
              type="text"
              label="Poly Cloud Service Email"
              className="form-control"
              name="cloudServiceEmail"
              placeholder="Email address of Poly Cloud Service account"
              pattern="[^@]+@[^@]+\.[a-zA-Z]{2,}"
              title="Valid email address <user>@<domain>"
              required
            />

            <Button
              style={{ marginRight: '.15em' }}
              type="submit"
              variant={theme?.buttonVariant}
              size="lg"
              disabled={isSubmitting || !values.cloudServiceEmail}
            >
              NEXT
            </Button>
            <Button
              variant={theme?.buttonVariant}
              size="lg"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
}

CloudServiceEmail.propTypes = {
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
};

export default CloudServiceEmail;
